module.exports = __webpack_public_path__ + "img/base_divers_tel_portable.e72f707b.svg";